import { render, staticRenderFns } from "./CentreSummary.vue?vue&type=template&id=7b52cd40&scoped=true&"
import script from "./CentreSummary.vue?vue&type=script&lang=js&"
export * from "./CentreSummary.vue?vue&type=script&lang=js&"
import style0 from "./CentreSummary.vue?vue&type=style&index=0&id=7b52cd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52cd40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
